import React from 'react';
import {IcTxtArrowSmallThin} from '@defign/ui';
import className from 'classnames/bind';

import style from './MyhouseMainCalculatorBanner.module.scss';
import {HEADER_HEIGHT, MAIN_CALCULATOR_ID} from '@Root/contants/myhouse';

const cx = className.bind(style);

const MyhouseMainCalculatorBanner = () => {
    const handleClickBanner = (event: React.SyntheticEvent) => {
        event.preventDefault();

        const mainCalculatorElement = document.getElementById(MAIN_CALCULATOR_ID);

        if (!mainCalculatorElement) {
            return;
        }

        window.scrollBy(
            0,
            mainCalculatorElement.getBoundingClientRect().top + mainCalculatorElement.scrollTop - HEADER_HEIGHT
        );
    };

    return (
        <div className={cx('article')}>
            <button type="button" className={cx('button')} onClick={handleClickBanner}>
                <span className={cx('badge')}>대출계산기</span>
                <span className={cx('text')}>대출 갈아타면 이득일지 계산해 보세요!</span>
                <span className={cx('icon')}>
                    <IcTxtArrowSmallThin width={6} height={10} fill="#09aa5c" />
                </span>
            </button>
        </div>
    );
};

export default MyhouseMainCalculatorBanner;
